import { SketchPicker } from 'react-color';
import React, { useState } from 'react';
import RMButton from 'components/customComponents/Controls/RMButton';
export default function ColorPicker({ color, setShowModal, onChangeColor }) {
  const [tempColor, setTempColor] = useState(color);
  return (
    <>
      <div
        id="controls-container"
        data-testid="controls-container"
        style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', padding: '2%' }}
      >
        <div
          id="controls-colorpicker-wrapper"
          data-testid="controls-colorpicker-wrapper"
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <SketchPicker
            id="controls-colorpicker"
            data-testid="controls-colorpicker"
            style={{ width: '20rem' }}
            color={tempColor}
            onChangeComplete={(clr) => setTempColor(clr.rgb)}
            className="clr-pkr"
          />
        </div>
        <div
          id="controls-colorpicker-button-wrapper"
          data-testid="controls-colorpicker-button-wrapper"
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '0.5rem',
            justifyContent: 'center',
          }}
        >
          <RMButton
            id="controls-colorpicker-button-ok"
            data-testid="controls-colorpicker-button-ok"
            customStyle={{
              width: '6rem',
              height: '2rem',
              maxHeight: '2rem',
              minHeight: '2rem',
              borderRadius: '0.5rem',
              fontSize: '1.25rem',
              lineHeight: '1.45rem',
            }}
            onClick={(e) => {
              onChangeColor(tempColor);
              setShowModal(false);
            }}
            label="OK"
          ></RMButton>
          <RMButton
            id="controls-colorpicker-button-cancel"
            data-testid="controls-colorpicker-button-cancel"
            customStyle={{
              width: '6rem',
              height: '2rem',
              maxHeight: '2rem',
              minHeight: '2rem',
              borderRadius: '0.5rem',
              fontSize: '1.25rem',
              lineHeight: '1.45rem',
            }}
            onClick={(e) => {
              setTempColor(color);
              setShowModal(false);
            }}
            label="Cancel"
          ></RMButton>
        </div>
      </div>
    </>
  );
}
